import React from 'react';
import Link from 'next/link';
import styles from './Privacy.module.scss';

const Privacy = () => (
  <div className={styles.Privacy}>
    <div className="header">
      <h1>Bounced Inc. Privacy Policy</h1>
    </div>
    <div className="overview">
      <p>
        This Privacy Notice applies to personal information which Bounced Inc.,
        310 Bagot Street, Kingston, ON, K7K 3B4, collects through this website (
        <a href="/">www.bouncelife.com</a>) (“Website”) and through our mobile
        app (“App”). Below are highlights and details of our personal
        information handling practices.
      </p>
    </div>

    <div className="section">
      <h1>
        <strong>
          <u>Private Notice Highlights</u>
        </strong>
      </h1>
      <br />
      <h2>
        <strong>Who We Collect Information From</strong>
      </h2>
      <p>
        We currently collect only information provided by the visitor and user
        of the Website and App.
      </p>
      <br />
      <h2>
        <strong>What Personal Information We Collect</strong>
      </h2>

      <p>
        We collect information:
        <ul>
          <li>
            That you provide through the forms you fill out during account
            creation, online customer service enquiries, and surveys;
          </li>
          <li>That you provide when you submit a payment;</li>
          <li>
            • Automatically when you visit our Website and when you use our App,
            including information about the device with which you logged into
            our Website, your location when you are using our App on your mobile
            device, your web browser, your IP address, time zone, cookies
            installed on your device, and information on the search terms that
            referred you to our Website and App (iOS).
          </li>
        </ul>
      </p>
      <br />
      <h2>
        <strong>How we use and disclose your information</strong>
      </h2>
      <p>
        <ul>
          <li>
            We use your information to communicate with you and personalize your
            user experience by sending out periodic emails to you and receiving
            feedback to improve our Website and App;
          </li>
          <li>
            We may use your information to create aggregated and anonymized data
            for analytical purposes.
          </li>
        </ul>
      </p>
      <br />
      <h2>
        <strong>How do we obtain your consent</strong>
      </h2>
      <p>
        By using our Website and App, you consent to our collection, use, and
        disclosure of your personal information as outlined in this policy. Your
        consent is the legal basis for our use of your personal information. You
        can withdraw your consent at any time. However, if you withdraw your
        consent to certain uses, we may no longer be able to provide our
        services to you.
        <br />
        <br />
        Your account settings allow you to change your communication preferences
        with respect to emails. You may also close your account if you want to
        withdraw your consent from our further use of your information. We may,
        however, retain information about your previous transactions for audit
        purposes, to ensure the integrity of our data and to fulfill legal
        requirements.
      </p>
      <br />
      <h2>
        <strong>How to contact us</strong>
      </h2>
      <p>
        To delete an account, go to Account Settings, select Login & Security,
        and click Delete Account at the bottom. Confirm your decision in the
        pop-up to permanently delete your account and data. If you&apos;re
        unable to delete your account for any reason, please reach out to our
        support team at{' '}
        <a href="mailto:help@bouncedinc.com">help@bouncedinc.com</a>, and we’ll
        assist you.
        <br />
      </p>
      <br />
      <h1>
        <u>Detailed Privacy Policy</u>
      </h1>
      <br />
      <h2>
        <strong>About Us</strong>
      </h2>
      <p>
        This website (<Link href="/">www.bouncelife.com</Link>) (“Website”) and
        our mobile app (“App”) are operated by Bounced Inc., company
        registration number 1055646-7. We are located at 310 Bagot Street,
        Kingston, ON, K7K 3B4.
        <br />
        <br />
        We have appointed a Chief Privacy Officer who is accountable for our
        personal information handling practices. Our Chief Privacy Officer is
        Sean Monteiro. If you have a question or complaint about our personal
        information handling practices, please contact us using our web form
        using the following link:{' '}
        <a href="mailto:help@bouncedinc.com">help@bouncedinc.com</a>
        .
        <br />
        <br />
        In this Privacy Notice, the terms &quot;we&quot;, &quot;our&quot; and
        &quot;us&quot; mean Bounced Inc..
      </p>
      <br />
      <h2>
        <strong>Effective Date and Scope</strong>
      </h2>
      <p>
        This Privacy Notice is effective as of June 18, 2019.
        <br />
        <br />
        This Privacy Notice governs our practices with respect to personal
        information we collect through our Website{' '}
        <a href="/">www.bouncelife.com</a>, and our App Bounce.
      </p>
      <br />
      <h2>
        <strong>What Personal Information We Collect</strong>
      </h2>
      <p>
        We collect Device Information using the following technologies:
        <ul>
          <li>
            “Cookies” are data files that are placed on your device or computer
            and often include an anonymous unique identifier. For more
            information about cookies, and how to disable cookies, visit{' '}
            <a href="http://www.allaboutcookies.org">
              http://www.allaboutcookies.org
            </a>
            .
          </li>
          <li>
            “Log files” track actions occurring on the Site, and collect data
            including your IP address, browser type, Internet service provider,
            referring/exit pages, and date/time stamps.
          </li>
        </ul>
        We collect information that you provide during the registration, and/or
        at the time at which you update your user profile with additional
        information. This information includes:
        <ul>
          <li>Name</li>
          <li>Email Address</li>
          <li>Date of birth</li>
          <li>Phone number</li>
          <li>Credit card number</li>
          <li>Online banking information</li>
          <li>Location while using our App</li>
        </ul>
      </p>
      <br />
      <h2>
        <strong>How We Use Your Information</strong>
      </h2>
      <p>
        We use your information to connect event vendors with event attendees
        through our Website and App. We may use your information to:
        <br />
        <br />
        <ul>
          <li>Register your account;</li>
          <li>Authenticate you when you log into your account;</li>
          <li>
            Coordinate with attendees and event hosts. This is the primary
            function of the Website;
          </li>
          <li>
            Communicate with you about your requests. Your email address or
            phone number which you provided upon registration will be used to
            notify you of event status updates;
          </li>
          <li>
            Personalize your user experience: We may use information in the
            aggregate to understand how our users as a group use the services
            and resources provided on our Site;
          </li>
          <li>
            Improve our Site: We continually strive to improve our website
            offerings based on the information and feedback we receive from you.
          </li>
          <li>
            Recommend or offer you information on events selected based on your
            preferred interests and location.
          </li>
        </ul>
        <br />
        Our Website and App use Stripe online payment platform (“Stripe”) to
        collect payment. Please refer to Stripe Global Privacy Policy at:{' '}
        <a href="https://stripe.com/en-ca/privacy">
          https://stripe.com/en-ca/privacy
        </a>
      </p>
      <br />
      <h2>
        <strong>Sharing your information to others</strong>
      </h2>
      <p>
        The following information we collected from you will be made available
        to hosts of events that you have selected to attend using our Website
        and App:
        <br />
        <br />
        <ul>
          <li>Name</li>
          <li>Email Address</li>
          <li>Phone number</li>
        </ul>
        <br />
        We may transfer any information we have about you in connection with a
        merger or sale (including transfers made as part of insolvency or
        bankruptcy proceedings) involving all or part of our business or as part
        of a corporate reorganization or stock sale or other change in corporate
        control.
      </p>
      <br />
      <h2>
        <strong>Law Enforcement Requests</strong>
      </h2>
      <p>
        We will disclose personal information without your knowledge or consent
        if we receive an order, subpoena, warrant or other legal requirement
        issued by a court, tribunal, regulator or other person with jurisdiction
        to compel disclosure of your personal information.
      </p>
      <br />
      <h2>
        <strong>How we collect your information</strong>
      </h2>
      <p>
        We collect Device Information using the following technologies:
        <br />
        <br />
        <ul>
          <li>
            “Cookies” are data files that are placed on your device or computer
            and often include an anonymous unique identifier. For more
            information about cookies, and how to disable cookies, visit{' '}
            <a href="http://www.allaboutcookies.org">
              http://www.allaboutcookies.org
            </a>
            .
          </li>
          <li>
            “Log files” track actions occurring on the Site, and collect data
            including your IP address, browser type, Internet service provider,
            referring/exit pages, and date/time stamps.
          </li>
        </ul>
      </p>
      <br />
      <h2>
        <strong>Data Retention</strong>
      </h2>
      <p>
        We will retain your personal information for as long as:
        <br />
        <br />
        <ul>
          <li>Your account is active;</li>
          <li>
            Your personal information is needed to provide you services; or
          </li>
          <li>
            It is necessary to meet legal, regulatory, insurance and audit
            requirements.
          </li>
        </ul>
        <br />
        In order to delete your account and Personal Data on Bounce, we ask that
        you contact the Bounce support team with your request using the form
        found on the following page{' '}
        <Link href="/contact">www.bouncelife.com/contact</Link>.
      </p>
      <br />
      <h2>
        <strong>Accuracy of Your Personal Information</strong>
      </h2>
      <p>
        We will use commercially reasonable efforts to ensure that your personal
        information is correct, complete and up-to-date to the extent we are
        notified of any changes by you. You can review and update your personal
        information on our Website and App. You can assist by keeping us
        informed of any changes or informing us if you find any errors in our
        information about you. If we have disclosed inaccurate information about
        you to a third party that you are aware of, we would be pleased to
        contact the third party in order to correct the information upon your
        request.
      </p>
      <br />
      <h2>
        <strong>Security Measures</strong>
      </h2>
      <p>
        We take reasonable measures, including administrative, physical and
        technical safeguards, to protect your information from loss, theft,
        misuse, unauthorized access, disclosure, alteration and destruction.
        Personal information uploaded to our Website is transmitted to us using
        industry standard encryption, which creates a private conversation
        between your computer and our Website. We authenticate our Website and
        enable TLS/SSL encryption to protect your sensitive data and
        transactions.
      </p>
      <br />
      <h2>
        <strong>Revision of Policy</strong>
      </h2>
      <p>
        This policy may be revised from time to time. We will notify you of
        material changes prior to such material change being effective, either
        by e-mail at the address you have provided to us in connection with your
        registration on our website or by a prominent notice on our Website and
        App. Your continued use of our Website or App, or failure to cancel your
        account on our Website or App following such notification shall
        constitute your acceptance of the revised policy. We encourage you to
        periodically review this page for the latest information on our privacy
        practices.
      </p>
      <br />
      <h2>
        <strong>Disputes and Complaints</strong>
      </h2>
      <p>
        This policy is subject to our Terms of Use, including terms regarding
        the governing law and the resolution of any disputes between us. If you
        have a complaint with respect to our privacy policy, please contact us
        at the link provided under “Contact Us”.
      </p>
      <br />
      <h2>
        <strong>Revision of Policy</strong>
      </h2>
      <p>
        Our Website and App are not intended for children. If we become aware
        that we have inadvertently received or collected personal information
        pertaining to a child under the age of consent in the country where the
        child is located without valid consent, we will delete such information
        from our records.
      </p>
    </div>
  </div>
);

export default Privacy;
